import { OrderStatus } from './order-status';

export enum OrderStage {
  CREATION = 'creation',
  ROUTE_VERIFICATION = 'route-verification',
  VEHICLE_SEARCH = OrderStatus.VEHICLE_SEARCH,
  ENGINE_PROPOSAL = 'engine-proposal',
  MANUAL_PROPOSAL = 'manual-proposal',
  OUTSOURCING = 'outsourcing',
  REALIZATION = 'realization',
  COMPLETING_DOCUMENTS = OrderStatus.COMPLETING_DOCUMENTS,
  WAITING_FOR_COLLECTIVE_INVOICE = 'waiting-for-collective-invoice',
  INVOICE_TO_ISSUE = OrderStatus.INVOICE_TO_ISSUE,
  PAYMENT_CONFIRMATION = 'payment-confirmation',
}
